// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = '7da9f26f398197cad3cd95d7a5b6c6ed6341fbb3';
/* tslint:enable */
